import { Button } from "@msuite/ui/button";
import { useDisclosure } from "@msuite/ui/hooks";
import { Icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import type { TicketResourceLink } from "@msuite/utils/types";
import { Fragment } from "react";
import { ResourceLinksModal } from "@/modals/projects/resource-links-modal";

/** Props Interface */
interface TicketCardResourceLinksProps {
	resourceLinks: TicketResourceLink[];
}

export function TicketCardResourceLinks({ resourceLinks }: TicketCardResourceLinksProps) {
	/** Hooks */
	const { t } = useTranslation();
	const disclosure = useDisclosure();

	/** Guard */
	if (!resourceLinks.length) return null;

	/** Render */
	return (
		<Fragment>
			<Button
				variant="plain"
				className="gap-1 h-stack w-max text-xs"
				icon={
					<Icon
						name="Link"
						className="stroke-accent-500"
					/>
				}
				stopPropagation
				onClick={disclosure.onOpen}
				data-cy="ticket-card-resource-links"
			>
				{resourceLinks.length} {t("resource_links.links")}
			</Button>
			{disclosure.isOpen && (
				<ResourceLinksModal
					resourceLinks={resourceLinks}
					isOpen={disclosure.isOpen}
					onClose={disclosure.onClose}
				/>
			)}
		</Fragment>
	);
}
